import BlogFortyTwoContainer from "./container/BlogFortyTwoContainer";
export default BlogFortyTwoContainer;
